import { Grommet, Box, Main, Heading, Paragraph, Anchor, TextInput, Button, Text, Spinner } from 'grommet';
import { useState } from 'react';
import { Checkmark, Close } from 'grommet-icons';

const theme = {
  "name": "cloudflare",
  "rounding": 4,
  "spacing": 24,
  "defaultMode": "light",
  "global": {
    "colors": {
      "brand": {
        "dark": "#FAAD3F",
        "light": "#F48120"
      },
      "background": {
        "dark": "#111111",
        "light": "#FFFFFF"
      },
      "background-back": {
        "dark": "#111111",
        "light": "#EEEEEE"
      },
      "background-front": {
        "dark": "#222222",
        "light": "#FFFFFF"
      },
      "background-contrast": {
        "dark": "#FFFFFF11",
        "light": "#11111111"
      },
      "text": {
        "dark": "#EEEEEE",
        "light": "#333333"
      },
      "text-strong": {
        "dark": "#FFFFFF",
        "light": "#000000"
      },
      "text-weak": {
        "dark": "#CCCCCC",
        "light": "#444444"
      },
      "text-xweak": {
        "dark": "#999999",
        "light": "#666666"
      },
      "border": {
        "dark": "#444444",
        "light": "#CCCCCC"
      },
      "control": "brand",
      "active-background": "background-contrast",
      "active-text": "text-strong",
      "selected-background": "brand",
      "selected-text": "text-strong",
      "status-critical": "#FF4040",
      "status-warning": "#FFAA15",
      "status-ok": "#00C781",
      "status-unknown": "#CCCCCC",
      "status-disabled": "#CCCCCC",
      "graph-0": "brand",
      "graph-1": "status-warning"
    },
    "font": {
      "family": "\"Noto Sans\"",
      "face": "/* cyrillic-ext */\n@font-face {\n  font-family: 'Noto Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/notosans/v12/o-0IIpQlx3QUlC5A4PNr6DRASf6M7VBj.woff2) format('woff2');\n  unicode-range: U+0460-052F, U+1C80-1C88, U+20B4, U+2DE0-2DFF, U+A640-A69F, U+FE2E-FE2F;\n}\n/* cyrillic */\n@font-face {\n  font-family: 'Noto Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/notosans/v12/o-0IIpQlx3QUlC5A4PNr4TRASf6M7VBj.woff2) format('woff2');\n  unicode-range: U+0400-045F, U+0490-0491, U+04B0-04B1, U+2116;\n}\n/* devanagari */\n@font-face {\n  font-family: 'Noto Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/notosans/v12/o-0IIpQlx3QUlC5A4PNr5DRASf6M7VBj.woff2) format('woff2');\n  unicode-range: U+0900-097F, U+1CD0-1CF6, U+1CF8-1CF9, U+200C-200D, U+20A8, U+20B9, U+25CC, U+A830-A839, U+A8E0-A8FB;\n}\n/* greek-ext */\n@font-face {\n  font-family: 'Noto Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/notosans/v12/o-0IIpQlx3QUlC5A4PNr6TRASf6M7VBj.woff2) format('woff2');\n  unicode-range: U+1F00-1FFF;\n}\n/* greek */\n@font-face {\n  font-family: 'Noto Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/notosans/v12/o-0IIpQlx3QUlC5A4PNr5jRASf6M7VBj.woff2) format('woff2');\n  unicode-range: U+0370-03FF;\n}\n/* vietnamese */\n@font-face {\n  font-family: 'Noto Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/notosans/v12/o-0IIpQlx3QUlC5A4PNr6jRASf6M7VBj.woff2) format('woff2');\n  unicode-range: U+0102-0103, U+0110-0111, U+0128-0129, U+0168-0169, U+01A0-01A1, U+01AF-01B0, U+1EA0-1EF9, U+20AB;\n}\n/* latin-ext */\n@font-face {\n  font-family: 'Noto Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/notosans/v12/o-0IIpQlx3QUlC5A4PNr6zRASf6M7VBj.woff2) format('woff2');\n  unicode-range: U+0100-024F, U+0259, U+1E00-1EFF, U+2020, U+20A0-20AB, U+20AD-20CF, U+2113, U+2C60-2C7F, U+A720-A7FF;\n}\n/* latin */\n@font-face {\n  font-family: 'Noto Sans';\n  font-style: normal;\n  font-weight: 400;\n  src: url(https://fonts.gstatic.com/s/notosans/v12/o-0IIpQlx3QUlC5A4PNr5TRASf6M7Q.woff2) format('woff2');\n  unicode-range: U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF, U+FFFD;\n}\n"
    },
    "active": {
      "background": "active-background",
      "color": "active-text"
    },
    "hover": {
      "background": "active-background",
      "color": "active-text"
    },
    "selected": {
      "background": "selected-background",
      "color": "selected-text"
    }
  },
  "chart": {},
  "diagram": {
    "line": {}
  },
  "meter": {}
}

const CHECKER_URL = "https://submissions.apply.cloudflareworkers.com/check"

function App() {
  const [results, setResults] = useState(null)
  const [tunnel, setTunnel] = useState("")
  const [worker, setWorker] = useState("")
  const [email, setEmail] = useState("")
  const [fetching, setFetching] = useState(false)
  const [errorMessage, setErrorMessage] = useState("")

  const getResults = async () => {
    if (!tunnel || !email) return
    setErrorMessage("")
    setResults(null)
    try {
      let x = new URL(tunnel)
      if (!x.hostname.endsWith(".trycloudflare.com")) {
        setErrorMessage("URL should end with 'trycloudflare.com'")
        return
      }
    } catch {
      setErrorMessage("Invalid URL")
      return
    }
    setFetching(true)
    let response = await fetch(CHECKER_URL, {
      method: "POST",
      body: JSON.stringify({url: tunnel, worker, email})
    })
    setFetching(false)
    if (response.status !== 200) {
      setErrorMessage(await response.text())
      return
    }
    let res = await response.json()
    setResults(res)
  }

  return (
    <Grommet theme={theme}>
      <Main>
        <Heading textAlign="center" alignSelf="center">Cloudflare Systems Assignment Grader</Heading>
        <Paragraph alignSelf="center" style={{maxWidth: "none", width: "50%"}}>
          Congratulations on completing your Systems Assignment! This page is a quick and easy way to tell how you did, and
          you can absolutely go back and make changes if something didn't work the first time.
          <br/><br/>
          First, follow our <Anchor href="instructions" label="instructions"/> to get a Cloudflare Tunnel set up with your submission.
          <br/><br/>
          Next, enter your tunnel link below and run the grader. If you did the extra credit, enter your frontend assignment's workers.dev link
          (remember to update your worker with the current tunnel URL if it has changed).
        </Paragraph>
        <Box width="40%" alignSelf="center">
          <TextInput placeholder="https://your-tunnel-link.trycloudflare.com" value={tunnel} onChange={e => setTunnel(e.target.value)}
                      onKeyPress={e => {if (e.key === "Enter") getResults()}}/>
        </Box>
        <Box alignSelf="center" width="40%" margin="xsmall">
          <TextInput placeholder="yourname@email.com" value={email} onChange={e => setEmail(e.target.value)}
                      onKeyPress={e => {if (e.key === "Enter") getResults()}}/>
        </Box>
        <Box alignSelf="center" width="40%" margin="xsmall">
          <TextInput placeholder="https://your-frontend-worker.workers.dev (extra credit)" value={worker} onChange={e => setWorker(e.target.value)}
                      onKeyPress={e => {if (e.key === "Enter") getResults()}}/>
        </Box>
        <Button primary label="Run" onClick={getResults} style={{width: "max-content"}} alignSelf="center"/>
        {
          errorMessage !== ""
            ? <Text margin="small" alignSelf="center" textAlign="center" color="status-critical">{errorMessage}</Text>
            : null
        }
        {
          fetching ? <Spinner alignSelf="center" size="medium" margin="small"/> : results
          ? <Box direction="column" style={{width: "max-content"}} alignSelf="center"> {/* Results from the autograder */}
            <Heading level="4" alignSelf="center" textAlign="center" margin={{bottom: "none"}}>Successfully submitted your score.</Heading>
            <Heading level="4" alignSelf="center" textAlign="center">Your Score: {results.score}%</Heading>
            {results.results.normal.map(([test, result]) =>
              <Box direction="row" key={test}>
                {result ? <Checkmark color="green"/> : <Close color="red"/>}
                <Text margin={{left: "small"}}>{test}</Text>
              </Box>
            )}
            <Heading level="4" alignSelf="center" textAlign="center">Extra Credit: </Heading>
            {results.results.extraCredit.map(([test, result]) =>
              <Box direction="row" key={test}>
                {result ? <Checkmark color="green"/> : <Close color="red"/>}
                <Text margin={{left: "small"}}>{test}</Text>
              </Box>
            )}
          </Box> : null
        }
      </Main>
    </Grommet>
  );
}

export default App;
